<template>
  <div>
    <b-select
      expanded
      ref="select"
      v-show="!isAddMode"
      v-model="currSelect"
      v-bind="$attrs"
      @input="onSelectInput"
    >
      <option
        v-for="(val, idx) in newValue"
        :value="val"
        :key="idx"
      >
        {{ val }}
      </option>
      <option value="-1">
        Add New
      </option>
    </b-select>
    <b-input
      ref="input"
      v-show="isAddMode"
      v-model="currInput"
      v-bind="$attrs"
      @blur="onInputBlur"
      @keyup.enter.native="onInputEnter"
    />
  </div>
</template>

<script>
import { uniq } from 'lodash'

export default {
  name: 'EditableSelect',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isAddMode: false,
      currSelect: '',
      currInput: '',
      newValue: []
    }
  },
  created () {
    this.newValue = this.value.concat(this.newValue)
  },
  watch: {
    value (val) {
      this.newValue = val
    },
    isAddMode (val) {
      if (val) {
        this.$refs['input'].focus()
      } else {
        this.$refs['select'].focus()
      }
    }
  },
  methods: {
    onSelectInput (value) {
      this.currSelect = value
      if (value) {
        this.isAddMode = true
        if (value !== '-1') {
          this.currInput = value
        } else {
          this.currInput = ''
        }
      }
    },
    onInputBlur () {
      if (this.currInput !== '-1') { this.input() }
      this.currSelect = ''
      this.isAddMode = false
    },
    onInputEnter () {
      this.isAddMode = false
    },
    input () {
      if (this.currSelect === '-1') {
        const newValue = uniq([this.currInput].concat(this.newValue)).filter(val => val !== '')
        this.$emit('input', newValue)
      } else {
        if (this.currInput === '') {
          const idx = this.newValue.indexOf(this.currSelect)
          this.newValue.splice(idx, 1).filter(val => val !== '')
          this.$emit('input', this.newValue)
        } else {
          const idx = this.newValue.indexOf(this.currSelect)
          this.newValue[idx] = this.currInput
          this.$emit('input', this.newValue.filter(val => val !== ''))
        }
      }
    }
  }
}
</script>
